const ChevronRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="m19.175 30.808 2.972 2.677L30.692 24l-8.545-9.485-2.972 2.677 6.132 6.807z" />
    </svg>
);

export default ChevronRight;
